// removed by extract-text-webpack-plugin
module.exports = {"peopleMainInfo":"Person__peopleMainInfo___3nePj","peopleMainInfoLeft":"Person__peopleMainInfoLeft___1m-ny","peopleMainInfoRight":"Person__peopleMainInfoRight___3dHzt"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/PersonDetail/components/Person.scss
// module id = 1218
// module chunks = 1